import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"

import { usePriceChangesPriceEvolutionData } from "./@hooks"
import PriceChangesPriceEvolutionChartToolbar from "./Toolbar"


export default function PriceChangesPriceStockEvolutionChart() {

    const { 
        dataEvolution, dataEvolutionKeys, skuName, isLoadingDataEvolution, currency, resetEvolutionData, 
        retailer, chartColors, dateRange, onChangeDate
    } = usePriceChangesPriceEvolutionData()
    
    if (!dataEvolution?.length || isLoadingDataEvolution) return <></>

    const statusLabels = {
		'stock': 'Stock',
		'out-of-stock': 'Out Of Stock',
		'deslisted': 'Delisted',
		'not-listed': 'Not Listed'
	}
    
    return <ModalSeeker 
        hideActions 
        isOpen={!!dataEvolution?.length} 
        title={`Price & Stock Evolution - ${skuName} - ${retailer}`} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            rootID='price-stock-evolution'
            data={dataEvolution}
            title={<Box id="evolution-price-chart"></Box>}
            pdfProps={{
                titlePDF:`Price & Stock Evolution - ${skuName} - ${retailer}`
            }}
            series={[
                {
                    name: "Price",
                    yField: "price",
                    xField: "date",
                    type: "line",
                    connect: true,
                    tooltip: {
                        labelText: "[bold]Price: {valueY}[/]",
                    }, 
                },
                ...(dataEvolutionKeys.map(key => ({
                    name: statusLabels[key], 
                    yField: key,
                    xField: "date",
                    color: chartColors[key],
                    strokes: {
                        strokeDasharray: [0, 100000]
                    },
                    bullets: { 
                        hidden: false, 
                        radius: 10,
                        fill: chartColors[key]
                    },
                    tooltip: {
                        labelText: "[bold]{statusLabel}[/]"
                    },
                }))),	
            ]}
            chartProps={{
                numberFormat: `#,###.00 ' ${currency}'`,
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                }
            }}
            cardProps={{ 
                actions: 
                <PriceChangesPriceEvolutionChartToolbar
                    dateRange={dateRange}
                    onChangeDate={onChangeDate}
                /> 
            }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}